import { z } from 'zod';

import { Currency } from '../brand/brand';
import { makeEndpoint } from '../common';
import { PublicListing } from '../listing/listing';

export interface IVibe {
  id: string;
  name: string;
  order: number | null;
}

export interface ILocation {
  longitude: number;
  latitude: number;
  name: string;
  additionalInfo?: string;
  timezoneId?: string;
}

export interface IPriceTier {
  name: string;
  price: number;
  maxQuantity?: number;
}

export interface ICategory {
  id: string;
  name: string;
  order: number | null;
}

export type IPublicExperienceDetailResponse = Omit<
  PublicListing,
  'supportedCurrencies' | 'defaultPriceTiers' | 'defaultMaxParticipantCount'
> & {
  currency: Currency;
  priceTiers: PublicListing['defaultPriceTiers'];
  isNoHost: boolean;
  maxParticipantsCount: PublicListing['defaultMaxParticipantCount'];
};

const GetExperienceResourceGroupCollectionIdEndpointSchema = z.object({
  resourceGroupCollectionId: z.string().uuid(),
});

export const GetExperienceResourceGroupCollectionIdEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ experienceId }: { experienceId: string }) => `/v1/experiences/${experienceId}/resource-group-collection-id`,
  requestSchema: z.void(),
  responseSchema: GetExperienceResourceGroupCollectionIdEndpointSchema,
});
